import { render, staticRenderFns } from "./Motivoscrud.vue?vue&type=template&id=4977d07c&scoped=true"
import script from "./Motivoscrud.vue?vue&type=script&lang=js"
export * from "./Motivoscrud.vue?vue&type=script&lang=js"
import style0 from "./Motivoscrud.vue?vue&type=style&index=0&id=4977d07c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4977d07c",
  null
  
)

export default component.exports